var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g4, _path24, _path25, _path26, _path27, _g5, _path28, _path29, _path30, _g6, _path31, _path32, _path33, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessDeniedGraphics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 190,
    viewBox: "0 0 226 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1192 149.234L8.27924 124.998C6.12391 124.11 5.01014 121.703 5.72216 119.472L20.9035 71.8997C21.6566 69.5396 24.1686 68.2407 26.5141 68.9985C26.6113 69.0299 26.7073 69.0646 26.8021 69.1027L85.6479 92.7058C87.8201 93.5771 88.9548 95.9883 88.2482 98.2312L73.0611 146.437C72.3167 148.8 69.8095 150.108 67.4612 149.359C67.3456 149.322 67.2315 149.28 67.1192 149.234Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_10838_107925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1192 149.234L8.27924 124.998C6.12391 124.11 5.01014 121.703 5.72216 119.472L20.9035 71.8997C21.6566 69.5396 24.1686 68.2407 26.5141 68.9985C26.6113 69.0299 26.7073 69.0646 26.8021 69.1027L85.6479 92.7058C87.8201 93.5771 88.9548 95.9883 88.2482 98.2312L73.0611 146.437C72.3167 148.8 69.8095 150.108 67.4612 149.359C67.3456 149.322 67.2315 149.28 67.1192 149.234Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5416 148.196C67.6258 148.23 67.7113 148.262 67.7981 148.289C69.5593 148.851 71.4397 147.87 71.998 146.098L87.1851 97.8921C87.715 96.21 86.864 94.4015 85.2348 93.7481L26.3891 70.1449C26.318 70.1164 26.2459 70.0903 26.1731 70.0668C24.4139 69.4984 22.53 70.4726 21.9651 72.2427L6.78377 119.815C6.24976 121.488 7.08509 123.294 8.70159 123.959L67.5416 148.196Z",
    stroke: "#8A8FA1",
    strokeWidth: 1.84314
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2742 151.311L7.43419 127.075C4.20119 125.743 2.53053 122.133 3.59855 118.786L18.7799 71.2137C19.9096 67.6736 23.6776 65.7252 27.1958 66.862C27.3416 66.9091 27.4857 66.9612 27.6279 67.0182L86.4736 90.6214C89.7319 91.9283 91.434 95.5451 90.3741 98.9095L75.187 147.115C74.0703 150.659 70.3096 152.622 66.7871 151.498C66.6137 151.443 66.4426 151.38 66.2742 151.311Z",
    stroke: "white",
    strokeWidth: 3.68627
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2451 115.571L29.0783 92.0079",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5537 120.059L43.625 89.7638",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9813 120.059L52.017 103.228",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0694 85.2232L20.4321 23.9921C19.5402 21.6815 20.6787 19.0809 22.975 18.1834C23.0005 18.1734 23.0262 18.1637 23.0519 18.1541L59.2867 4.76049C60.5504 4.29335 61.9563 4.42557 63.1122 5.12028L83.6869 17.4865L102.117 64.0045C103.029 66.307 101.914 68.9177 99.6254 69.8356C99.5766 69.8552 99.5274 69.8739 99.478 69.8917L49.7316 87.8234C47.4558 88.6438 44.9447 87.4906 44.0694 85.2232Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_10838_107925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0694 85.2232L20.4321 23.9921C19.5402 21.6815 20.6787 19.0809 22.975 18.1834C23.0005 18.1734 23.0262 18.1637 23.0519 18.1541L59.2867 4.76049C60.5504 4.29335 61.9563 4.42557 63.1122 5.12028L83.6869 17.4865L102.117 64.0045C103.029 66.307 101.914 68.9177 99.6254 69.8356C99.5766 69.8552 99.5274 69.8739 99.478 69.8917L49.7316 87.8234C47.4558 88.6438 44.9447 87.4906 44.0694 85.2232Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.791 18.255L62.5404 6.08358C61.6735 5.56255 60.6191 5.46338 59.6712 5.81373L23.4365 19.2074C23.4076 19.2182 23.4076 19.2182 23.3788 19.2293C21.6565 19.9024 20.8027 21.8529 21.4717 23.5859L45.1089 84.817C45.7654 86.5176 47.6487 87.3824 49.3556 86.7671L99.1019 68.8355C99.1575 68.8151 99.1575 68.8151 99.2125 68.7934C100.929 68.1049 101.765 66.1469 101.081 64.42L82.791 18.255Z",
    stroke: "#8A8FA1",
    strokeWidth: 1.84314
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9905 86.0358L18.3532 24.8046C17.0153 21.3388 18.723 17.4378 22.1675 16.0916C22.2251 16.0693 22.2251 16.0693 22.2829 16.0477L58.5176 2.65405C60.4133 1.95334 62.5221 2.15168 64.2559 3.19375L85.479 15.9496L104.189 63.1735C105.557 66.6273 103.884 70.5433 100.451 71.9202C100.341 71.9636 100.341 71.9636 100.23 72.0044L50.4838 89.9361C47.07 91.1666 43.3034 89.4369 41.9905 86.0358Z",
    stroke: "white",
    strokeWidth: 3.68627
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6725 30.2953L52.5759 23.563",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1486 41.5158L71.5985 29.1733",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1002 63.9567L80.5502 51.6142",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6244 52.7362L52.5766 49.3701",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7657 43.7599L78.3131 38.1496",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.655 99.9534L169.059 22.8426C170.068 20.5819 172.707 19.5714 174.954 20.5855L213.548 37.9988C214.863 38.5921 215.812 39.788 216.096 41.2096L220.119 61.3513L192.811 126.48C191.853 128.764 189.237 129.834 186.967 128.871C186.927 128.854 186.888 128.837 186.849 128.819L136.873 105.875C134.642 104.85 133.651 102.205 134.655 99.9534Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_10838_107925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.655 99.9534L169.059 22.8426C170.068 20.5819 172.707 19.5714 174.954 20.5855L213.548 37.9988C214.863 38.5921 215.812 39.788 216.096 41.2096L220.119 61.3513L192.811 126.48C191.853 128.764 189.237 129.834 186.967 128.871C186.927 128.854 186.888 128.837 186.849 128.819L136.873 105.875C134.642 104.85 133.651 102.205 134.655 99.9534Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.673 100.413C134.919 102.102 135.662 104.085 137.336 104.854L187.312 127.798C187.356 127.818 187.356 127.818 187.4 127.837C189.103 128.559 191.065 127.757 191.783 126.044L218.958 61.2335L215.002 41.4306C214.789 40.3644 214.078 39.4675 213.092 39.0225L174.498 21.6092C172.812 20.8487 170.833 21.6065 170.077 23.3021L135.673 100.413V100.413ZM135.673 100.413V100.413V100.413Z",
    stroke: "#8A8FA1",
    strokeWidth: 1.84314
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.69 100.873L136.69 100.873L136.69 100.873ZM132.621 99.0344L132.621 99.0344L167.025 21.9237C168.538 18.5325 172.496 17.0169 175.866 18.5379L214.46 35.9512C216.433 36.8412 217.856 38.6351 218.282 40.7675L222.441 61.5868L194.865 127.353C193.429 130.778 189.505 132.384 186.1 130.938C186.011 130.9 186.011 130.9 185.923 130.86L135.947 107.916C132.6 106.38 131.114 102.412 132.621 99.0344Z",
    stroke: "white",
    strokeWidth: 3.68627
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M174.543 38.1496L194.684 47.126",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M167.829 47.126L187.971 56.1024",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M196.922 60.5906L205.875 65.0788",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M172.305 58.3465L196.922 71.8111",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M167.829 69.567L192.446 83.0315",
    stroke: "#D0D1D9",
    strokeWidth: 3.68627,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M138.296 106.28L198.891 84.7197C201.213 83.8933 203.762 85.1178 204.583 87.4548C204.643 87.6248 204.693 87.7983 204.732 87.9743L214.475 131.941C214.702 132.964 214.566 134.034 214.09 134.966L205.874 151.079L157.314 167.427C154.978 168.213 152.451 166.945 151.669 164.595C151.658 164.56 151.647 164.526 151.636 164.491L135.52 111.833C134.816 109.532 136.041 107.083 138.296 106.28Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_10838_107925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.296 106.28L198.891 84.7197C201.213 83.8933 203.762 85.1178 204.583 87.4548C204.643 87.6248 204.693 87.7983 204.732 87.9743L214.475 131.941C214.702 132.964 214.566 134.034 214.09 134.966L205.874 151.079L157.314 167.427C154.978 168.213 152.451 166.945 151.669 164.595C151.658 164.56 151.647 164.526 151.636 164.491L135.52 111.833C134.816 109.532 136.041 107.083 138.296 106.28Z",
    fill: "white"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.089 150.16L213.098 134.454C213.454 133.755 213.557 132.952 213.387 132.185L203.643 88.2184C203.614 88.0864 203.577 87.9563 203.532 87.8288C202.916 86.0761 201.005 85.1577 199.263 85.7775L138.668 107.338C136.976 107.94 136.058 109.777 136.586 111.502L152.702 164.161C152.714 164.2 152.714 164.2 152.727 164.238C153.313 166.002 155.209 166.953 156.961 166.363L205.089 150.16Z",
    stroke: "#8A8FA1",
    strokeWidth: 1.84314
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.552 104.165L198.147 82.6041C201.631 81.3645 205.454 83.2013 206.686 86.7067C206.776 86.9618 206.85 87.222 206.908 87.486L216.652 131.453C216.992 132.987 216.788 134.592 216.074 135.991L207.443 152.917L158.022 169.555C154.518 170.735 150.727 168.833 149.554 165.307C149.529 165.23 149.529 165.23 149.505 165.152L133.389 112.493C132.333 109.043 134.17 105.368 137.552 104.165Z",
    stroke: "white",
    strokeWidth: 3.68627
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.511 133.264C182.911 132.862 183.561 132.862 183.962 133.264C184.362 133.665 184.362 134.317 183.962 134.718L181.061 137.627C179.057 139.636 175.81 139.636 173.807 137.627C171.804 135.619 171.804 132.363 173.807 130.355L179.61 124.536C181.613 122.528 184.859 122.528 186.862 124.536C187.263 124.938 187.263 125.589 186.862 125.991C186.462 126.393 185.812 126.393 185.412 125.991C184.21 124.786 182.262 124.786 181.061 125.991L175.258 131.809C174.056 133.014 174.056 134.967 175.258 136.172C176.46 137.378 178.407 137.378 179.61 136.172L182.511 133.264ZM195.42 123.227L189.038 129.627C187.036 131.635 183.789 131.635 181.786 129.627C181.385 129.225 181.385 128.574 181.786 128.172C182.187 127.77 182.836 127.77 183.237 128.172C184.438 129.377 186.386 129.377 187.588 128.172L193.97 121.772C195.172 120.568 195.172 118.614 193.97 117.41C192.769 116.205 190.82 116.205 189.618 117.41L186.138 120.899C185.737 121.301 185.087 121.301 184.687 120.899C184.286 120.498 184.286 119.847 184.687 119.445L188.167 115.955C190.171 113.947 193.418 113.947 195.42 115.955C197.423 117.963 197.423 121.219 195.42 123.227Z",
    fill: "#8A8FA1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3967 124.169C76.9687 124.474 75.5487 124.987 74.0982 125.732C67.7499 117.35 57.511 113.327 47.5671 115.446C34.8886 118.149 26.137 130.166 26.7942 143.691C20.8486 147.242 17.7936 154.431 19.3166 161.616C21.2405 170.693 29.8039 176.587 38.403 174.754L86.9267 164.412C97.439 162.171 104.076 151.323 101.725 140.227C99.3726 129.131 88.909 121.929 78.3967 124.169Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_10838_107925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.3967 124.169C76.9687 124.474 75.5487 124.987 74.0982 125.732C67.7499 117.35 57.511 113.327 47.5671 115.446C34.8886 118.149 26.137 130.166 26.7942 143.691C20.8486 147.242 17.7936 154.431 19.3166 161.616C21.2405 170.693 29.8039 176.587 38.403 174.754L86.9267 164.412C97.439 162.171 104.076 151.323 101.725 140.227C99.3726 129.131 88.909 121.929 78.3967 124.169Z",
    fill: "white"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6278 125.267C77.29 125.552 75.9624 126.034 74.6053 126.731L73.7758 127.157L73.2113 126.412C67.0998 118.342 57.2823 114.522 47.7982 116.543C35.701 119.122 27.2752 130.612 27.908 143.636L27.9408 144.311L27.3633 144.656C21.8078 147.973 18.9895 154.693 20.4072 161.382C22.2052 169.864 30.1868 175.358 38.1719 173.656L86.6956 163.314C96.5927 161.204 102.86 150.962 100.634 140.461C98.4079 129.959 88.5262 123.157 78.6278 125.267Z",
    stroke: "#8A8FA1",
    strokeWidth: 1.84314
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.53 142.492C24.4276 128.389 33.782 116.09 47.1049 113.251C57.3009 111.077 67.8103 114.842 74.7426 122.967C75.8016 122.532 76.8621 122.202 77.9345 121.974C89.6747 119.471 101.302 127.475 103.906 139.759C106.51 152.045 99.1315 164.104 87.3888 166.607L38.8651 176.95C29.0381 179.044 19.311 172.348 17.1353 162.084C15.5191 154.459 18.4778 146.753 24.53 142.492L24.53 142.492Z",
    stroke: "white",
    strokeWidth: 3.68627
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M119.722 184.016C143.452 162.431 159.406 141.972 167.583 122.638C175.76 103.305 180.318 75.2685 181.257 38.5285C164.04 38.9041 151.886 37.3887 144.792 33.982C137.699 30.5754 129.342 22.2401 119.722 8.97638C112.201 21.8203 104.604 30.1555 96.9318 33.982C89.2593 37.8085 77.1043 39.324 60.4669 38.5285C59.9423 78.392 62.981 106.429 69.5831 122.638C76.1852 138.848 92.8983 159.307 119.722 184.016Z",
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_10838_107925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.722 184.016C143.452 162.431 159.406 141.972 167.583 122.638C175.76 103.305 180.318 75.2685 181.257 38.5285C164.04 38.9041 151.886 37.3887 144.792 33.982C137.699 30.5754 129.342 22.2401 119.722 8.97638C112.201 21.8203 104.604 30.1555 96.9318 33.982C89.2593 37.8085 77.1043 39.324 60.4669 38.5285C59.9423 78.392 62.981 106.429 69.5831 122.638C76.1852 138.848 92.8983 159.307 119.722 184.016Z",
    fill: "white"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.727 182.497C142.931 161.266 158.537 141.159 166.556 122.199C174.582 103.223 179.109 75.7075 180.111 39.673C163.351 39.959 151.437 38.4163 144.312 34.9946C137.264 31.6097 129.122 23.6139 119.819 11.0015C112.477 23.1952 105.028 31.1962 97.427 34.9873C89.7302 38.8258 77.789 40.3809 61.5676 39.701C61.1184 78.8096 64.1479 106.335 70.6149 122.213C77.079 138.084 93.4516 158.201 119.727 182.497Z",
    stroke: "#8A8FA1",
    strokeWidth: 1.84314
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.216 185.671C91.1699 160.758 74.2748 140.076 67.5193 123.489C60.7742 106.928 57.7084 78.6419 58.2367 38.4986L58.2672 36.1765L60.5726 36.2868C76.8648 37.0657 88.6798 35.5926 95.9412 31.9712C103.159 28.3715 110.479 20.3397 117.801 7.83701L119.523 4.89517L121.524 7.65336C130.944 20.642 139.07 28.7472 145.753 31.9566C152.454 35.1747 164.313 36.6534 181.209 36.2847L183.547 36.2337L183.486 38.586C182.541 75.5838 177.94 103.88 169.635 123.517C161.315 143.188 145.168 163.894 121.218 185.68L119.713 187.049L118.216 185.671Z",
    stroke: "white",
    strokeWidth: 3.68627
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M134.26 89.764C133.024 89.764 132.022 88.7592 132.022 87.5199V85.7695C132.15 79.8559 127.803 74.8005 121.952 74.0553C118.795 73.7372 115.653 74.7773 113.306 76.917C110.958 79.0567 109.627 82.0949 109.643 85.2758V87.5199C109.643 88.7592 108.641 89.764 107.405 89.764C103.697 89.764 100.691 92.7781 100.691 96.4962V112.205C100.691 115.923 103.697 118.937 107.405 118.937H134.26C137.968 118.937 140.974 115.923 140.974 112.205V96.4962C140.974 92.7781 137.968 89.764 134.26 89.764ZM114.119 85.2758C114.119 83.2539 115.024 81.3389 116.586 80.06C118.148 78.7811 120.2 78.2738 122.176 78.6781C125.363 79.401 127.606 82.2688 127.547 85.5451V87.5199C127.547 88.7592 126.545 89.764 125.309 89.764H116.357C115.121 89.764 114.119 88.7592 114.119 87.5199V85.2758Z",
    fill: "#8A8FA1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_10838_107925",
    x: 5.50769,
    y: 68.7824,
    width: 82.95,
    height: 80.7874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.14379,
    dy: -6.14379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10838_107925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_10838_107925",
    x: 20.1283,
    y: 4.4852,
    width: 82.307,
    height: 83.6023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.14379,
    dy: -6.14379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10838_107925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_10838_107925",
    x: 134.263,
    y: 20.1914,
    width: 85.8558,
    height: 109.033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.45752,
    dy: -6.14379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10838_107925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_10838_107925",
    x: 135.322,
    y: 84.4617,
    width: 79.2604,
    height: 83.1982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.14379,
    dy: -2.45752
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10838_107925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_10838_107925",
    x: 18.9285,
    y: 114.888,
    width: 83.2698,
    height: 60.2004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.14379,
    dy: -6.14379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10838_107925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_10838_107925",
    x: 60.4089,
    y: 8.97638,
    width: 120.848,
    height: 175.039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.14379,
    dy: -6.14379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10838_107925"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDeniedGraphics);
export default __webpack_public_path__ + "static/media/access_denied_graphics.937920a1.svg";
export { ForwardRef as ReactComponent };